import { TARGET } from "../../constants/target.qwik.mjs";
import { handleABTesting } from "../../helpers/ab-tests.qwik.mjs";
import { getDefaultCanTrack } from "../../helpers/canTrack.qwik.mjs";
import { logger } from "../../helpers/logger.qwik.mjs";
import { getSdkHeaders } from "../../helpers/sdk-headers.qwik.mjs";
import { fetch } from "../get-fetch.qwik.mjs";
import { isBrowser } from "../is-browser.qwik.mjs";
import { generateContentUrl } from "./generate-content-url.qwik.mjs";
const checkContentHasResults = (content) => "results" in content;
async function fetchOneEntry(options) {
  const allContent = await fetchEntries({
    ...options,
    limit: 1
  });
  if (allContent)
    return allContent[0] || null;
  return null;
}
const _fetchContent = async (options) => {
  var _a;
  const url = generateContentUrl(options);
  const _fetch = options.fetch ?? fetch;
  const fetchOptions = {
    ...options.fetchOptions,
    headers: {
      ...(_a = options.fetchOptions) == null ? void 0 : _a.headers,
      ...getSdkHeaders()
    }
  };
  const res = await _fetch(url.href, fetchOptions);
  const content = await res.json();
  return content;
};
const _processContentResult = async (options, content, url = generateContentUrl(options)) => {
  const canTrack = getDefaultCanTrack(options.canTrack);
  url.search.includes(`preview=`);
  if (!canTrack)
    return content.results;
  if (!(isBrowser() || TARGET === "reactNative"))
    return content.results;
  try {
    const newResults = [];
    for (const item of content.results)
      newResults.push(await handleABTesting({
        item,
        canTrack
      }));
    content.results = newResults;
  } catch (e) {
    logger.error("Could not process A/B tests. ", e);
  }
  return content.results;
};
async function fetchEntries(options) {
  const url = generateContentUrl(options);
  const content = await _fetchContent(options);
  if (!checkContentHasResults(content)) {
    logger.error("Error fetching data. ", {
      url,
      content,
      options
    });
    throw content;
  }
  return _processContentResult(options, content);
}
export {
  _processContentResult,
  fetchEntries,
  fetchOneEntry
};
